import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ChargingEventsContainer = styled.div`
  height: 100%;
`;
export const Title = styled.div``;

export const EventsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${pxToRem('20px')};
  padding-bottom: ${pxToRem('20px')};
`;
